import { render, staticRenderFns } from "./Slotxo.vue?vue&type=template&id=5d50d163&scoped=true"
import script from "./Slotxo.vue?vue&type=script&lang=js"
export * from "./Slotxo.vue?vue&type=script&lang=js"
import style0 from "./Slotxo.vue?vue&type=style&index=0&id=5d50d163&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50d163",
  null
  
)

export default component.exports